export const chainId = {
    BNB: 56,
    ETH_SEPOLIA: 1,

};